import React from 'react';

const ReferralCode = props => {
  const { code } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="158"
      height="57"
      viewBox="0 0 158 57"
    >
      <defs>
        <linearGradient
          id="prefix__b"
          x1="45.397%"
          x2="47.132%"
          y1="56.507%"
          y2="44.74%"
        >
          <stop offset="0%" stopColor="#F68A11" />
          <stop offset="100%" stopColor="#FBA83F" />
        </linearGradient>
        <linearGradient
          id="prefix__a"
          x1="0%"
          x2="100%"
          y1="43.493%"
          y2="56.507%"
        >
          <stop offset="0%" stopColor="#FFE58E" />
          <stop offset="100%" stopColor="#FFCE5B" />
        </linearGradient>
        <filter
          id="prefix__c"
          width="106.9%"
          height="126.4%"
          x="-3.4%"
          y="-6.6%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.830729167 0 0 0 0 0.475915705 0 0 0 0 0.0742400875 0 0 0 1 0"
          />
        </filter>
        <text
          id="prefix__d"
          fill="#FFEFCD"
          fontFamily="ProductSans-Bold, Product Sans"
          fontSize="23.572"
          fontWeight="bold"
          letterSpacing="4.5"
        >
          <tspan x="20" y="36.347">
            {code}
          </tspan>
        </text>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#prefix__b)"
          stroke="url(#prefix__a)"
          strokeWidth="1.684"
          d="M158 0v6.706c-2.785 0-5.043 2.252-5.043 5.03 0 2.777 2.258 5.029 5.043 5.029h0v6.706c-2.785 0-5.043 2.251-5.043 5.029s2.258 5.03 5.043 5.03h0v6.705c-2.785 0-5.043 2.252-5.043 5.03 0 2.777 2.258 5.03 5.043 5.03h0V57h-6.723c0-2.778-2.258-5.03-5.043-5.03s-5.043 2.252-5.043 5.03h0-6.723c0-2.778-2.258-5.03-5.042-5.03-2.785 0-5.043 2.252-5.043 5.03h0-6.723c0-2.778-2.258-5.03-5.043-5.03s-5.043 2.252-5.043 5.03h0-6.723c0-2.778-2.258-5.03-5.042-5.03-2.785 0-5.043 2.252-5.043 5.03h0-6.723c0-2.778-2.258-5.03-5.043-5.03s-5.043 2.252-5.043 5.03h0-6.723c0-2.778-2.258-5.03-5.043-5.03-2.784 0-5.042 2.252-5.042 5.03h0-6.723c0-2.778-2.258-5.03-5.043-5.03S40.34 54.223 40.34 57h0-6.723c0-2.778-2.258-5.03-5.043-5.03-2.784 0-5.042 2.252-5.042 5.03h0-6.723c0-2.778-2.258-5.03-5.043-5.03S6.723 54.223 6.723 57h0H0v-6.706c2.785 0 5.043-2.252 5.043-5.03 0-2.777-2.258-5.029-5.043-5.029h0V33.53c2.785 0 5.043-2.251 5.043-5.029S2.785 23.47 0 23.47h0v-6.705c2.785 0 5.043-2.252 5.043-5.03 0-2.777-2.258-5.03-5.043-5.03h0V0h6.723c0 2.778 2.258 5.03 5.043 5.03S16.809 2.777 16.809 0h6.723c0 2.778 2.258 5.03 5.042 5.03 2.785 0 5.043-2.252 5.043-5.03h6.723c0 2.778 2.258 5.03 5.043 5.03S50.426 2.777 50.426 0h6.723c0 2.778 2.258 5.03 5.042 5.03 2.785 0 5.043-2.252 5.043-5.03h6.723c0 2.778 2.258 5.03 5.043 5.03S84.043 2.777 84.043 0h6.723c0 2.778 2.258 5.03 5.043 5.03 2.784 0 5.042-2.252 5.042-5.03h6.723c0 2.778 2.258 5.03 5.043 5.03S117.66 2.777 117.66 0h6.723c0 2.778 2.258 5.03 5.043 5.03 2.784 0 5.042-2.252 5.042-5.03h6.723c0 2.778 2.258 5.03 5.043 5.03s5.043-2.252 5.043-5.03H158z"
        />
        <g fill="#FFEFCD">
          <use filter="url(#prefix__c)" xlinkHref="#prefix__d" />
          <use xlinkHref="#prefix__d" />
        </g>
        <path
          stroke="#FFF"
          strokeWidth="1.684"
          d="M15.967 12.57H142.034V44.43H15.967z"
          opacity=".18"
        />
      </g>
    </svg>
  );
};

export default ReferralCode;
